import React from 'react';
import styled from 'styled-components';
import {useParams} from 'react-router';
import Compnay from './Company';
import Csvfile from './Csvfile';
import Jobs from './Jobs';
import PressRelease from './PressRelease';
import Fiscal from './Fiscal';
import {StringParam, useQueryParam} from 'use-query-params';
import CompanyEdit from './Company/CompanyEdit';
import KeyPerson from './KeyPerson';
import AiAssist from 'components/Prelead/AiAssist';
import {useCurrentUserQuery, usePreleadProjectQuery, useCurrentClientQuery} from 'api';

export default () => {
  const {preleadProjectId} = useParams<{preleadProjectId: string}>();
  const [information, setInformation] = useQueryParam(
    'information',
    StringParam,
  );
  const {data: {currentUser = null} = {}} = useCurrentUserQuery({});
  const {data: {currentClient: {currentPreleadContract} = {}} = {}} = useCurrentClientQuery();
  const {data: {preleadProject: {prelead = null} = {}} = {}} =
    usePreleadProjectQuery({
      variables: {uuid: preleadProjectId},
      skip: !preleadProjectId,
    });

  if (!preleadProjectId || !information) return null;

  if (information === 'company_edit') {
    return (
      <Container>
        <CompanyEdit onClose={() => setInformation('company')} />
      </Container>
    );
  }

  return (
    <Container>
      <ContentWrapper>
        {information === 'ai_assist' &&
          (currentUser?.role === 'admin' ||
            currentPreleadContract?.canUseAiCompanyResearch) && (
            <AiAssist preleadUuid={prelead?.uuid} aiAssist={prelead?.aiAssist} />
          )}
        {information === 'company' && <Compnay />}
        {information === 'csvfile' && <Csvfile />}
        {information === 'jobs' && <Jobs />}
        {information === 'pressrelease' && <PressRelease />}
        {information === 'fiscal' && <Fiscal />}
        {information === 'key_person' && <KeyPerson />}
      </ContentWrapper>
    </Container>
  );
};

const Container = styled.div`
  width: 400px;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #ffffff;
  border-left: 1px solid var(--border-color);
`;

const ContentWrapper = styled.div`
  overflow: scroll;
  padding: 20px 30px 0 30px;
`;
